import { ContractorsVM, Department, WorkArea } from "../entities/global/model";

export class GETPerfomeInductionVM {
    public Users: UsersVM[];
    public InductionTypes: InductionTypes[];

    public LogUser: string;

    public Results: InductionExternalAttendeeseVM[]

    public ExternalUserData: InductionExternalAttendeeseVM;

    public States: StateVM[];
}

export class StateVM {
    public ID: number;
    public SideCode: string;
    public StateName: string
}

export class UsersVM {
    public UserAuto: number;

    public UserId: string;

    public UserName: string;

    public suspended:boolean;
}



export class InductionTypes {
    public ID: number

    public Title: string;

    public Description: string;

    public ExpiryMonths: number | null;
}

export class InductionExternalAttendeeseVM {
    public UserId: number
    public Fname: string;
    public Lname: string;
    public Company: string;
    public Position: string;
    public Email: string;
    public Photo: string;
    public check: boolean;
    //public bool Done { get; set; }

    public LastInductionInfo: InductionInfoVM

}

export class InductionInfoVM {
    public Id: number;
    public InductionId: number;
    public InductionType: number;
    public ExpiryMonths: number;
    public InductionDate: Date;
}

export class CreateNewInductionVM {
    public ExternaluserList: number[];
    public InternaluserList: number[];

    public InductionDate: Date;
    public InductionType: number;
    public StateId: number;
}

export class CreateExternalAttendeeVM {
    public Fname: string;
    public Lname: string;
    public Company: string;
    public Position: string;
    public Email: string;
    public Photo: string;
}

export class InductionVM {
    public InductionTypes: InductionTypes[]
    public Selections: InductionSlideSelection[]

    public success: boolean;

    public message: string

    public Results: IndcutionSearchVM[]

}



export class InductionSlideSelection {
    public ID: number;

    public Title: string

    public InductionType: number | null

    public Order: number;

    public Active: boolean
}

export class IndcutionSearchVM {
    public Date: string
    public  facilitatorName:string
    public Fname: string
    public Lname: string
    public Email: string
    public InductionType: string
    public Company: string
    public IsValid: boolean
    public State: string;

    public Id: number;
  
    public InductionDate: Date;
    public ExpirMonths: number | null;
    
    public TypeId: number;
    public facilitator:number
}

export class FormsVM {
    public Categories: FormCategory[];
    public Forms: Form[];
    public States: StateVM[]
}

export class FormCategory {
    public ID: number;

    public Name: string;

    public Description: string;

    public RequireIncidentNo: boolean;

    public Forms: Form[]
    public DaysCountFilter:number;
}

export class Form {
    public ID: number;

    public Name: string;

    public Description: string;

    public Filename: string;

    public Data: any[];

    public FormCategoryID: number;

    public Active: boolean;

    public IsDigital: boolean;

    public Safety: boolean;

}

export class FormUploadVM {
    public Id: number;

    public DateCompleted: string;

    public Form: string;

    public IncidentId: string;

    public IncidentType: number;

    public Images: string[]

    public File: string;

    public FileName: string[]

    public RelatedUser: number | null;

    public Notes: string;

    public FollowUpRequired: boolean

    public FollowUpCompleted: boolean

    public FollowUpDate: string | null;

    public FollowUpUser: number | null;
public FollowUpUserName:string;
    public CreatedUser: number;

    public CreatedDate: string;

    public ModifiedUser: number | null;

    public ModifiedDate: string | null;

    public FormCatId: number;
    public FormCatName: string;
    public FormName: string;
    public userName: string;
    public CompletedDate: string;
    public IncidentTypeName: string;
    public IsDigitalForm: boolean;
    public isSafety: boolean;
    public SiteId: number;
    public suspended:boolean
    public isArchived:boolean
}


export class ModalIncidentRequired {
    public id: number;
    public required: boolean;
}

export class ModalToggleForm {
    public formID: number;
    public active: boolean;
}

export class ModalFormData {
    public formName: string;
    public formDesc: string;
    public categoryID: number;
    public formID: number;
    public active: boolean;
    public formData: string;
    public fileName: string;
    public StateId: number|null;
}


export class VMCreateCategory {
    public  categoryName:string
    public  categoryDesc:string
    public days:number;

}



export class ModalFormCatData {
    public categoryName: string;
    public categoryDesc: string;
    public categoryID: number;
    public requireIncidentNo: boolean;
    public days:number;
}

export class DigitalFormVM {
    public FormId: number;
    public FormName: string;
    public FormCategoeryId: number;
    public FormCategoeryName: string;
    public Active: boolean;
    public EmailonComplete: boolean;
    public customerId: number[];
    public familyId: number[];
    public modelId: number[];
    public IsSafetyForm: boolean;
    public customerListName: string;
    public familyListName: string;
    public modelListName: string;
    public inspectorName: string;
    public Serial: string;
    public EquipmentId: number | null;
    public FormStatusID: number;
    public FormStatus: string;
    public EQCustomer: string;
    public EQJobsite: string;
    public EQMake: string;
    public EQModel: string;
    public FormStartDate: string;
    public Inspector: string;
    public RevisionNo: string;
    public StartByInspector: boolean;
    public Notes: string;
    public FECRForm: boolean;
    public FECRInspectionType: number;
}

export class DigitalFormQuestionsCategoriesVM {
    public QuestionCatId: number;
    public QCategoryName: string;
    public FormId: number;
    public Order: number;
    public QuestionCount: number;
    public IsParent: boolean;
    public ParentCatId: number | null;
    public ParentCatName: string;
    public SectionCount: number;
    public Active: boolean;
    public NotStartCount: number;
    public CompleteCount: number;
    public InProgressCount: number;

    public CatStatus: string;

    public hasFlag: boolean;
}

export class ObservationPoint {
    public ObservationPointId: number;
    public ObservationPointName: string;
    public ObservationPointPosX: number;
    public ObservationPointPosY: number;
    public schematic_auto: number | null;
    public observationPointTypeId: number | null;
    public numberOfReading: number | null;
    public UnabletoComplete: boolean;
    public pointLedgend: number;
    public obsUnabletoComplete: boolean;
    public comment: string;
    public componentId: number | null;
    public ObservationPointQuestionTitle: string;
    public ObservationPointQuestionInstruction: string;
    public FlagId: number;
    public isCrackFixed: boolean;

}

export class Schematic {
    public schematic_auto: number;
    public componentId: number;
    public schematic_attachement: string;
    public schematic_Filename: string;

}

export class Components {
    public ComponentTypeId: number | null;
    public ComponentTypeName: string;

    public ComponentId: number;
    public ComponentName: string;
    public ComponentObservationPointId: number;

    public ObservationPoint: ObservationPoint[]
    public Schematic: Schematic[]
}

export class ModelAnswerList {
    public AnswerId: number;
    public QuestionId: number;
    public Answer: string;
    public select: boolean;
    public QuestionName: string;
    public Components: Components[]


}

export class DigitalObservationDetailsVM {
    public ObPointId: number;
    public ReadingNumber: number;
    public Measurement: number;
    public Percentage: number;
    public UoM: number;
    public obsImages: string[];
    public ObservationPointId: number;
    public ObservationPointName: string;
    public ObservationPointPosX: number;
    public ObservationPointPosY: number;
    public comment: string;
    public componentId: number;
    public flag: boolean;
    public initialLength: number;
    public isNew: boolean;
    public numberOfReading: number;
    public schematic_auto: number;
    public select: boolean;
    public wornLength: number;
    public obsUnabletoComplete: boolean;
    public ObservationPointQuestion: string;
    public ObservationPointQuestionInstruction: string;
    public obsFlagID: number | null;
    public obsFlagComment: string;
    public obsFlagColour: string;
    public ObsPointTypeId: number;
    public LimitRange: number | null;
    public isCrackFixed: number;
}

export class DigitalFormQuestionsVM {
    public ShowUpArrow:boolean;
    public ShowDownArrow:boolean;
    public QuestionId: number;
    public QTitle: string;
    public QuestionTypeId: number;
    public QDescription: string;
    public Active: boolean;
    public AllowImages: boolean;
    public AllowComments: boolean;
    public FormId: number;

    public HasQuestionImage: boolean;
    public QuestionCatId: number;
    public Order: number;
    public ImageEdit: boolean;
    public QuestionTypeName: string;
    public QuestionNumber: number;
    public FormUploadId: number;
    public QuestionImage: string;
    public ModelAnswers: ModelAnswerList[]
    public UploadImages: string[];
    public EditedQuestionImage: string;
    public QuestionComment: string;
    public UnableToComplete: boolean;
    public UploadId: number;
    public inspectorId: number | null;
    public InspectorName: string;
    public Flag: boolean;
    public SchematicList: Schematic[]
    public ObservationDetails: DigitalObservationDetailsVM[]
    public QuestionFlag: number | null;
    public FlagColor: string;

    public FlagClearComment: string;
    public ClearFlag: boolean;

    public FlagComment: string;
    public updateFlag: boolean;
    public AnswerDate: string;

    public QStatus: number;
    public hasCompleteFlag: boolean;
}

export class DigitalFormQuestionTypesVM {
    public Id: number;
    public Title: string;
}

export class FormStatusTypesVM {
    public ID: number;
    public Status: string;
}

export class FlagTypesVM {
    public ID: number;
    public Name: string;
    public Color: string;
    public CompleteColor: string;
    public EmailSend: boolean;
}

export class FormListV1{
    public FormCategory: DigitalFormQuestionsCategoriesVM;
    public Questions: DigitalFormQuestionsVM[];
}

export class DigitalFormSetupVM {
    public Form: DigitalFormVM;
    public FormCategories: DigitalFormQuestionsCategoriesVM[];
    public Questions: DigitalFormQuestionsVM[];
    public QuestionTypes: DigitalFormQuestionTypesVM
    public ParentCategories: DigitalFormQuestionsCategoriesVM[];
    public CategorySections: DigitalFormQuestionsCategoriesVM[];
    public FormStatusList: FormStatusTypesVM[];
    public FlagTypes: FlagTypesVM[]
    public FormListV1:FormListV1[]
}
export class AddNewDigitalQuestionsVM {
    public Title: string;
    public Desc: string;
    public QuestionTypeId: number;
    public CatId: number;
    public FormId: number;
    public QId: number;
    public Image: string;
}

export class AnswerListVM {
    public Id: number;
    public Qid: number;
    public QuestionName: string;
    public answer: string;
    public correct: boolean;
    public Anscount: number | null;
    public userSelectAnswer: boolean;
    public valid: boolean;

}

export class MultipleChoiceAnswer {
    public name: string;
    public select: boolean;
    public key: number;
}

export class AnswerList {
    public answer: string;
}

export class SaveAnswerForDigitalFormQuestionVM {
    public AnswerList: AnswerList[];
    public QId: number;
    public QType: number;
}

//form search
export class VMFormSearch {
    public FormCategories: FormCategory[];
    public Forms: Form[];
    public Users: UsersVM[];
    public Results: FormUploadVM[]
    public States:StateVM[]

}

export class SearchByParametersVM{
    public DateCompletedStart:any;
    public DateCompletedEnd:any;
    public FormCategory:number;
    public RelatedUser:number;
    public FollowUpRequired:boolean;
    public FollowUpCompleted:boolean;
    public Form:number;
    public StateId:number;
    public PersonResponsible:number;
    public DueDateEnd:Date;
    public DueDateStart:Date;
    public selectedCustomerId:number[];
    public isArchived:boolean
    public isActive:boolean


}


//safety Inspection Search
export class ChecklistQuestion {
    public ID: number

    public QuestionName: string
    public QuestionDescription: string

    public QuestionCategoryID: number

    public Active: boolean;
}

export class ChecklistCategory {
    public ID: number

    public CategoryName: string

    public CategoryDescription: string;
}
export class SafetyInpsectionSearchVM {
    public departments: Department[];
    public workArea: WorkArea[];

    public categories: ChecklistCategory[]
    public questions: ChecklistQuestion[]

    public contractors: ContractorsVM[]

    public States: StateVM[];
}

export class SearchByParametersSafetySearchVM {
    public DateCompletedStart: any;
    public DateCompletedEnd: any;
    public DateCompletedStart_: any;
    public DateCompletedEnd_: any;
    public Departments: number[];
    public WorkAreas: number[];
    public ChecklistCategories: number[];
    public ChecklistQuestions: number[];
    public States: number[];
    public Contractors: string[];

    public FollowUpRequired: boolean;
    public FollowUpCompleted: boolean;
    public OnlyUnsafe: boolean;
    public OnlyInspections: boolean;
    public ExcludeNA: boolean;
    public selectedCustomerId:number[];


}

export class InspectionSearchResultsVM {
    public DetailsId: number;

    public CompletedDate: string;

    public Department: string;

    public WorkArea: string;

    public Category: string;

    public Question: string;

    public SafeOrUnsafe: number;

    public Observer: string;
    public Contractor: string;
    public ExcludeNA: number;
}

export class UploadDigitalFormQuestionImageVM{
    public QId:number;
    public Image:string;
    public FormId:number
}

export class UpdateDigitalFormSectionVM{
    public SectionId:number;
    public SectionName:string;
    public FormId:number
}

export class UpdateDigitalFormNameVM{
    public FormId:number;
    public FormName:string;
}

export class InductionM{
    public Id;number
    public FacilitatorUserId:number
    public InductionTypeId:number
    public SiteId:number
}

export class TrainingRegFormsVM
{
    public  state :number
    public  positionID:number 
    public  fromID:number
    public  FormName:string
    public  CompletedDate:Date
    public  followUpDate:Date
    public IsExpired:boolean
    public StateName:string
    public postionName:string
    public createdUserName:string  
    public reltedUserId:number
    public reltedUserName:string
    public isPrint:boolean
}
export class TraningRegUserVM
{
    public  userID:number
    public  userName:string
    public  positionID:number
    public  USI:string
    public Forms:TrainingRegFormsVM[]
}
export class TraningRegSearchParametersVM{
    public FromID:number[]
    public PositionsIDs:number[]
    public SiteID:number[]
    public UserId:number[]

}

export class SearchFormVM{
public  FormId:number
public  FormName:string
}

export class ArchivedFormVM{
    FormUploaId:number
    isArchived:boolean
}